const StripeKeys = {
  PublishableStripeKey: process.env.REACT_APP_STRIPE_KEY,
  transactionPercentage: 3,
};
export default StripeKeys;
